import React from 'react';

const CaveIcon = (props) => {
  return (
    <img
      alt="Jaskinia"
      src="/static/images/icons/tourist_attractions/cave.svg"
      {...props}
    />
  );
};

export default CaveIcon;
